module.exports = __webpack_public_path__ + "static/one-to-one-mentoring-dcfe5da0b9974ca0dc454a2445b9e6ec.png";